module.exports = __webpack_public_path__ + "img/loginForm_bg.3656dd4b.png";